"use client";

import _defineProperty from "/Users/hicham/workspace/tamtam/storybook/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genFocusStyle, resetComponent } from '../../style';
import { initFadeMotion, initZoomMotion } from '../../style/motion';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';

function box(position) {
  return {
    position: position,
    inset: 0
  };
}

export var genModalMaskStyle = function genModalMaskStyle(token) {
  var _$concat;

  var componentCls = token.componentCls,
      antCls = token.antCls;
  return [_defineProperty({}, "".concat(componentCls, "-root"), (_$concat = {}, _defineProperty(_$concat, "".concat(componentCls).concat(antCls, "-zoom-enter, ").concat(componentCls).concat(antCls, "-zoom-appear"), {
    // reset scale avoid mousePosition bug
    transform: 'none',
    opacity: 0,
    animationDuration: token.motionDurationSlow,
    // https://github.com/ant-design/ant-design/issues/11777
    userSelect: 'none'
  }), _defineProperty(_$concat, "".concat(componentCls).concat(antCls, "-zoom-leave ").concat(componentCls, "-content"), {
    pointerEvents: 'none'
  }), _defineProperty(_$concat, "".concat(componentCls, "-mask"), Object.assign(Object.assign({}, box('fixed')), _defineProperty({
    zIndex: token.zIndexPopupBase,
    height: '100%',
    backgroundColor: token.colorBgMask,
    pointerEvents: 'none'
  }, "".concat(componentCls, "-hidden"), {
    display: 'none'
  }))), _defineProperty(_$concat, "".concat(componentCls, "-wrap"), Object.assign(Object.assign({}, box('fixed')), _defineProperty({
    zIndex: token.zIndexPopupBase,
    overflow: 'auto',
    outline: 0,
    WebkitOverflowScrolling: 'touch'
  }, "&:has(".concat(componentCls).concat(antCls, "-zoom-enter), &:has(").concat(componentCls).concat(antCls, "-zoom-appear)"), {
    pointerEvents: 'none'
  }))), _$concat)), _defineProperty({}, "".concat(componentCls, "-root"), initFadeMotion(token))];
};

var genModalStyle = function genModalStyle(token) {
  var _mediaMaxWidth$, _$concat4, _Object$assign3, _$concat6;

  var componentCls = token.componentCls;
  return [// ======================== Root =========================
  _defineProperty({}, "".concat(componentCls, "-root"), (_$concat4 = {}, _defineProperty(_$concat4, "".concat(componentCls, "-wrap-rtl"), {
    direction: 'rtl'
  }), _defineProperty(_$concat4, "".concat(componentCls, "-centered"), _defineProperty({
    textAlign: 'center',
    '&::before': {
      display: 'inline-block',
      width: 0,
      height: '100%',
      verticalAlign: 'middle',
      content: '""'
    }
  }, componentCls, {
    top: 0,
    display: 'inline-block',
    paddingBottom: 0,
    textAlign: 'start',
    verticalAlign: 'middle'
  })), _defineProperty(_$concat4, "@media (max-width: ".concat(token.screenSMMax, ")"), (_mediaMaxWidth$ = {}, _defineProperty(_mediaMaxWidth$, componentCls, {
    maxWidth: 'calc(100vw - 16px)',
    margin: "".concat(token.marginXS, " auto")
  }), _defineProperty(_mediaMaxWidth$, "".concat(componentCls, "-centered"), _defineProperty({}, componentCls, {
    flex: 1
  })), _mediaMaxWidth$)), _$concat4)), // ======================== Modal ========================
  _defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign3 = {
    pointerEvents: 'none',
    position: 'relative',
    top: 100,
    width: 'auto',
    maxWidth: "calc(100vw - ".concat(token.margin * 2, "px)"),
    margin: '0 auto',
    paddingBottom: token.paddingLG
  }, _defineProperty(_Object$assign3, "".concat(componentCls, "-title"), {
    margin: 0,
    color: token.titleColor,
    fontWeight: token.fontWeightStrong,
    fontSize: token.titleFontSize,
    lineHeight: token.titleLineHeight,
    wordWrap: 'break-word'
  }), _defineProperty(_Object$assign3, "".concat(componentCls, "-content"), {
    position: 'relative',
    backgroundColor: token.contentBg,
    backgroundClip: 'padding-box',
    border: 0,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadow,
    pointerEvents: 'auto',
    padding: "".concat(token.paddingMD, "px ").concat(token.paddingContentHorizontalLG, "px")
  }), _defineProperty(_Object$assign3, "".concat(componentCls, "-close"), Object.assign({
    position: 'absolute',
    top: (token.modalHeaderHeight - token.modalCloseBtnSize) / 2,
    insetInlineEnd: (token.modalHeaderHeight - token.modalCloseBtnSize) / 2,
    zIndex: token.zIndexPopupBase + 10,
    padding: 0,
    color: token.modalCloseIconColor,
    fontWeight: token.fontWeightStrong,
    lineHeight: 1,
    textDecoration: 'none',
    background: 'transparent',
    borderRadius: token.borderRadiusSM,
    width: token.modalCloseBtnSize,
    height: token.modalCloseBtnSize,
    border: 0,
    outline: 0,
    cursor: 'pointer',
    transition: "color ".concat(token.motionDurationMid, ", background-color ").concat(token.motionDurationMid),
    '&-x': {
      display: 'flex',
      fontSize: token.fontSizeLG,
      fontStyle: 'normal',
      lineHeight: "".concat(token.modalCloseBtnSize, "px"),
      justifyContent: 'center',
      textTransform: 'none',
      textRendering: 'auto'
    },
    '&:hover': {
      color: token.modalIconHoverColor,
      backgroundColor: token.wireframe ? 'transparent' : token.colorFillContent,
      textDecoration: 'none'
    },
    '&:active': {
      backgroundColor: token.wireframe ? 'transparent' : token.colorFillContentHover
    }
  }, genFocusStyle(token))), _defineProperty(_Object$assign3, "".concat(componentCls, "-header"), {
    color: token.colorText,
    background: token.headerBg,
    borderRadius: "".concat(token.borderRadiusLG, "px ").concat(token.borderRadiusLG, "px 0 0"),
    marginBottom: token.marginXS
  }), _defineProperty(_Object$assign3, "".concat(componentCls, "-body"), {
    fontSize: token.fontSize,
    lineHeight: token.lineHeight,
    wordWrap: 'break-word'
  }), _defineProperty(_Object$assign3, "".concat(componentCls, "-footer"), _defineProperty({
    textAlign: 'end',
    background: token.footerBg,
    marginTop: token.marginSM
  }, "".concat(token.antCls, "-btn + ").concat(token.antCls, "-btn:not(").concat(token.antCls, "-dropdown-trigger)"), {
    marginBottom: 0,
    marginInlineStart: token.marginXS
  })), _defineProperty(_Object$assign3, "".concat(componentCls, "-open"), {
    overflow: 'hidden'
  }), _Object$assign3))), // ======================== Pure =========================
  _defineProperty({}, "".concat(componentCls, "-pure-panel"), (_$concat6 = {
    top: 'auto',
    padding: 0,
    display: 'flex',
    flexDirection: 'column'
  }, _defineProperty(_$concat6, "".concat(componentCls, "-content,\n          ").concat(componentCls, "-body,\n          ").concat(componentCls, "-confirm-body-wrapper"), {
    display: 'flex',
    flexDirection: 'column',
    flex: 'auto'
  }), _defineProperty(_$concat6, "".concat(componentCls, "-confirm-body"), {
    marginBottom: 'auto'
  }), _$concat6))];
};

var genWireframeStyle = function genWireframeStyle(token) {
  var _componentCls, _confirmComponentCls, _ref6;

  var componentCls = token.componentCls,
      antCls = token.antCls;
  var confirmComponentCls = "".concat(componentCls, "-confirm");
  return _ref6 = {}, _defineProperty(_ref6, componentCls, (_componentCls = {}, _defineProperty(_componentCls, "".concat(componentCls, "-content"), {
    padding: 0
  }), _defineProperty(_componentCls, "".concat(componentCls, "-header"), {
    padding: token.modalHeaderPadding,
    borderBottom: "".concat(token.modalHeaderBorderWidth, "px ").concat(token.modalHeaderBorderStyle, " ").concat(token.modalHeaderBorderColorSplit),
    marginBottom: 0
  }), _defineProperty(_componentCls, "".concat(componentCls, "-body"), {
    padding: token.modalBodyPadding
  }), _defineProperty(_componentCls, "".concat(componentCls, "-footer"), {
    padding: "".concat(token.modalFooterPaddingVertical, "px ").concat(token.modalFooterPaddingHorizontal, "px"),
    borderTop: "".concat(token.modalFooterBorderWidth, "px ").concat(token.modalFooterBorderStyle, " ").concat(token.modalFooterBorderColorSplit),
    borderRadius: "0 0 ".concat(token.borderRadiusLG, "px ").concat(token.borderRadiusLG, "px"),
    marginTop: 0
  }), _componentCls)), _defineProperty(_ref6, confirmComponentCls, (_confirmComponentCls = {}, _defineProperty(_confirmComponentCls, "".concat(antCls, "-modal-body"), {
    padding: "".concat(token.padding * 2, "px ").concat(token.padding * 2, "px ").concat(token.paddingLG, "px")
  }), _defineProperty(_confirmComponentCls, "".concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    marginInlineEnd: token.margin
  }), _defineProperty(_confirmComponentCls, "".concat(confirmComponentCls, "-btns"), {
    marginTop: token.marginLG
  }), _confirmComponentCls)), _ref6;
};

var genRTLStyle = function genRTLStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-root"), _defineProperty({}, "".concat(componentCls, "-wrap-rtl"), _defineProperty({
    direction: 'rtl'
  }, "".concat(componentCls, "-confirm-body"), {
    direction: 'rtl'
  })));
}; // ============================== Export ==============================


export var prepareToken = function prepareToken(token) {
  var headerPaddingVertical = token.padding;
  var headerFontSize = token.fontSizeHeading5;
  var headerLineHeight = token.lineHeightHeading5;
  var modalToken = mergeToken(token, {
    modalBodyPadding: token.paddingLG,
    modalHeaderPadding: "".concat(headerPaddingVertical, "px ").concat(token.paddingLG, "px"),
    modalHeaderBorderWidth: token.lineWidth,
    modalHeaderBorderStyle: token.lineType,
    modalHeaderBorderColorSplit: token.colorSplit,
    modalHeaderHeight: headerLineHeight * headerFontSize + headerPaddingVertical * 2,
    modalFooterBorderColorSplit: token.colorSplit,
    modalFooterBorderStyle: token.lineType,
    modalFooterPaddingVertical: token.paddingXS,
    modalFooterPaddingHorizontal: token.padding,
    modalFooterBorderWidth: token.lineWidth,
    modalIconHoverColor: token.colorIconHover,
    modalCloseIconColor: token.colorIcon,
    modalCloseBtnSize: token.fontSize * token.lineHeight,
    modalConfirmIconSize: token.fontSize * token.lineHeight
  });
  return modalToken;
};
export var prepareComponentToken = function prepareComponentToken(token) {
  return {
    footerBg: 'transparent',
    headerBg: token.colorBgElevated,
    titleLineHeight: token.lineHeightHeading5,
    titleFontSize: token.fontSizeHeading5,
    contentBg: token.colorBgElevated,
    titleColor: token.colorTextHeading
  };
};
export default genComponentStyleHook('Modal', function (token) {
  var modalToken = prepareToken(token);
  return [genModalStyle(modalToken), genRTLStyle(modalToken), genModalMaskStyle(modalToken), token.wireframe && genWireframeStyle(modalToken), initZoomMotion(modalToken, 'zoom')];
}, prepareComponentToken);